module.exports = __webpack_public_path__ + "img/temperature-icon.5e65d175.svg";